import { render } from "./systemSet.vue?vue&type=template&id=3daa41f4"
import script from "./systemSet.vue?vue&type=script&lang=js"
export * from "./systemSet.vue?vue&type=script&lang=js"

import "./systemSet.vue?vue&type=style&index=0&id=3daa41f4&lang=scss"
script.render = render

export default script